import AboutCustomPreview from './AboutCustomPreview';
import VerifiedPaymentCustomPreview from './VerifiedPaymentCustomPreview';

export { AboutCustomPreview, VerifiedPaymentCustomPreview };
